import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Table from './Table';

const CoachStatuses = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  useEffect(() => {
    if (user?.permissions?.coach_statuses?.add_edit) {
      setCanUpdate(true);
    }
    if (user?.permissions?.coach_statuses?.delete) {
      setCanDelete(true);
    }
  }, [user]);

  return (
    <div className='page-top-div'>
      <span className='text-span'>Coach Statuses Manager</span>
      <Table canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default CoachStatuses;
